import React, { useCallback } from "react";
import {
  NodeViewWrapper,
  NodeViewContent,
  type NodeViewProps,
} from "@tiptap/react";

import { cn } from "@/lib/utils";

export function ImageRowComponent({ node, editor, getPos }: NodeViewProps) {
  const align = (node.attrs.align as string) || "left";
  const justifyClass =
    align === "center"
      ? "justify-center"
      : align === "right"
        ? "justify-end"
        : "justify-start";

  const moveCursorToRowEnd = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();
      event.stopPropagation();
      const start = typeof getPos === "function" ? getPos() : getPos;
      if (typeof start !== "number") return;
      if (node.childCount === 0) return;
      // imageRow 不含 inline 内容，TextSelection 无法置入；改为 NodeSelection 选中最后一张图
      const lastImgPos = start + node.nodeSize - 2;
      editor.commands.setNodeSelection(lastImgPos);
      editor.commands.focus();
    },
    [editor, getPos, node],
  );

  const handleWrapperClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      if (event.currentTarget !== event.target) return;
      moveCursorToRowEnd(event);
    },
    [moveCursorToRowEnd],
  );

  return (
    <NodeViewWrapper
      className="relative my-4 rounded-xl border border-slate-200 bg-slate-50/80 p-3 dark:border-slate-700 dark:bg-slate-900/70"
      data-image-row="true"
      onClick={handleWrapperClick}
    >
      <NodeViewContent
        className={cn(
          "flex w-full flex-nowrap items-start gap-3 overflow-x-auto",
          justifyClass,
        )}
        onClick={handleWrapperClick}
      />
    </NodeViewWrapper>
  );
}
